export const DEBOUNCE_TIME_500_MS = 500;
export const SECONDS_10 = 10000;
